import { useMutation, useQueryClient } from "@tanstack/react-query";

import { FEED_QUERY_KEYS } from "../queryKeys";
import { sharePost } from "../services/postServices";
import { CreatePostFormData } from "../types/feed.types";

interface UsePostShareMutationProps {
  postId: number;
}

export const usePostShareMutation = ({ postId }: UsePostShareMutationProps) => {
  const queryClient = useQueryClient();

  const shareMutation = useMutation({
    mutationFn: (data: CreatePostFormData) => sharePost(postId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...FEED_QUERY_KEYS.all, "posts", "list"] });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
    },
  });

  return {
    sharePost: shareMutation.mutate,
    isSharing: shareMutation.isPending,
  };
};
